export default __webpack_public_path__ + "images/CD.70b6afb.png";